export default "__VITE_ASSET__BiLuaUXz__"